import type React from "react";

import { CheckIcon, MinusIcon } from "lucide-react";

import { handleClickForKeyboard } from "simplydo/core/accessibility";
import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";

const CheckboxStyle = styled.div<{ $checked?: boolean }>`
  display: flex;
  width: 35px;
  height: 35px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  // border: 1px solid lightgray;
  background-color: ${({ $checked, theme }) =>
    $checked ? theme.primaryColour : "#e9ebee"};
  color: ${({ $checked }) => ($checked ? "#fff" : "gray")};

  cursor: pointer;
  > i {
    font-size: 2em;
    line-height: 1em;
    width: 1em;
    margin-right: 0;
  }
  &:hover {
    > i {
      font-size: 2em !important;
    }
  }
`;

interface LargeCheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  onChange: (
    event:
      | React.MouseEvent<HTMLDivElement>
      | React.KeyboardEvent<HTMLDivElement>,
    checked: boolean,
  ) => void;
  content?: React.ReactNode;
}

const LargeCheckbox = ({
  checked,
  indeterminate = false,
  onChange,
  content,
}: LargeCheckboxProps) => (
  <CheckboxStyle
    tabIndex={0}
    role="checkbox"
    aria-checked={indeterminate ? "mixed" : checked}
    $checked={checked || indeterminate}
    onClick={(e: React.MouseEvent<HTMLDivElement>) => onChange(e, !checked)}
    onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
      const handler = handleClickForKeyboard(() => onChange(e, !checked));
      handler?.(e);
    }}
  >
    {checked ? (
      <Icon icon={CheckIcon} />
    ) : indeterminate ? (
      <Icon icon={MinusIcon} />
    ) : null}
    {content}
  </CheckboxStyle>
);

export default LargeCheckbox;
